import React from "react";
import Field from "@gqlapp/forms-client-react/FieldAdapter";
import RenderCheckboxes from "@gqlapp/base/RenderCheckboxes";

export default (function Checkbox(props){
	let { id, name: label, options, setFieldValue: onChange, values } = props || {}

	let value = values[id];

	options = (options || []).map(({  title: label, ...props }, index)=>{
		let name = `${id}[${index}]`;
		return ({ ...props, name, label, value: index })
	})


	return <>
		<Field
			sx={{ width: '100%', '& .MuiFormControlLabel-root':{ margin: 0 }}}
			{...{ className: 'Mui-textfield', component: RenderCheckboxes }}
			{...{ options, onChange }}
			{...{ label, name: id, value }}
		/>
	</>
})